// See http://element.eleme.io/#/en-US/component/quickstart
// ("On demand" section) for how to add particular components
import ElementUI from 'element-ui'
import en from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

locale.use(en)

export default {
  install(Vue, options) {
    Vue.use(ElementUI)
  },
}
